function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#BFBBB7",
  strokeWidth: 0.757
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.117 15.767V4c0-.895-.726-1.621-1.621-1.621H2C1.105 2.379.379 3.105.379 4v11.767c0 .896.726 1.622 1.621 1.622h10.496c.895 0 1.621-.726 1.621-1.622z"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.813 1.352v2.304M6.146 1.352v2.304M8.48 1.352v2.304M10.813 1.352v2.304"
})), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M3.148 6.697H9.17M3.148 8.912h3.236M3.148 11.127H5.25M3.148 13.343H4.43"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.905 12.78v2.423l2.41-.253 5.918-6.573a.631.631 0 0 0-.047-.892L14.715 6.16a.631.631 0 0 0-.892.047L7.905 12.78z"
}));

var SvgLogs = function SvgLogs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logs.363cbdc0.svg";
export { ForwardRef as ReactComponent };